import { render, staticRenderFns } from "./MenuSizes.vue?vue&type=template&id=d5ee2936&"
import script from "./MenuSizes.vue?vue&type=script&lang=js&"
export * from "./MenuSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports